/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './DistrictView.scss';
import AddDistrictDetails from '../../Panels/AddDistrictDetails/AddDistrictDetails';
import ListViews from '../../Panels/ListViews/ListViews';
import BasePanel from '../../Panels';

class DistrictView extends React.Component {
  render() {
    return (
      <div>
       	<div className="col-sm-6">
          <BasePanel fullWidth user={this.props.user}  style={{textAlign: "center"}} userHasFeatureCode="0009" panelType="danger" panelTitle="Dodaj adres."><AddDistrictDetails /></BasePanel>
        </div>
        <div className="col-sm-6">
          <BasePanel fullWidth user={this.props.user}  style={{textAlign: "center"}} userHasFeatureCode="0009" panelType="danger" panelTitle="Lista wizyt."><ListViews /></BasePanel>
        </div>
      </div>
    );
  }
}

DistrictView.PropTypes = {
  viewName: PropTypes.string.isRequired,
  viewDesc: PropTypes.string.isRequired,
};

export default withStyles(s)(DistrictView);



// WEBPACK FOOTER //
// src/components/Modals/Settings/SettingsViews/DistrictView/DistrictView.js